(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fast-shiping-one-liner-text-btn"] && !Shopify.designMode) return;
  try {
    const btnShipFrm = document.getElementsByClassName("btn-frm-group");
const btnTypeAddToCart = document.getElementsByClassName("cv--atc");
const mobileQuery = window.matchMedia('(max-width:767px)');
if (btnShipFrm.length > 0) {
  btnShipFrm[0].style.display = "block";
  function handleTabletChange(e) {
  if (e.matches) {
     btnTypeAddToCart[0].style.width = "77.5%";
  } else {
    btnTypeAddToCart[0].style.width = "79.5%"; 
  }
}
mobileQuery.addEventListener('change', handleTabletChange);
handleTabletChange(mobileQuery);
}
  } catch(e) { console.error(e); }
})();

})();
